<template>
  <div>
    <LeftSidebar
      :visible="visible"
      baseClass="competency-score"
      :title="title"
      :hasHeaderRightIcon="false"
    >
      <template>
        <b-row class="margin-0 padding-16">
          <b-col cols="12" class="padding-0">
            <Input
              :title="$lang.summary"
              :label="$lang.summary"
              :placeholder="$lang.summary"
              :value="form.overall"
              name="overall"
              id="overall"
              type="textarea"
              :vuelidateObj="$v.form.overall"
              @input="input"
              @focus="resetValidation"
              @blur="checkValidation"
            />
          </b-col>
          <b-col cols="12" class="padding-0">
            <Input
              :title="$lang.strengthAndDevelopment"
              :label="$lang.strengthAndDevelopment"
              :placeholder="$lang.strengthAndDevelopment"
              :value="form.strengthAndDevelopment"
              name="strengthAndDevelopment"
              id="strengthAndDevelopment"
              type="textarea"
              :vuelidateObj="$v.form.strengthAndDevelopment"
              @input="input"
              @focus="resetValidation"
              @blur="checkValidation"
            />
          </b-col>
          <b-col cols="12" class="padding-0">
            <EnumDropdown
              :title="$lang.finalScore"
              :label="$lang.finalScore"
              :placeholder="$lang.finalScore"
              :value="form.finalScore"
              name="finalScore"
              id="finalScore"
              categoryName="competency_score"
              :vuelidateObj="$v.form.finalScore"
              :parentOptions="finalScoreOptions"
              rowClass=""
              @input="input"
              @focus="resetValidation"
              @blur="checkValidation"
            />
          </b-col>
        </b-row>
      </template>
      <template #footer>
        <Button
          variant="filled-complementary"
          :text="$lang.cancel"
          class="mobile-width-percent-100 tablet-width-percent-100"
          contentClass="justify-content-center"
          @click="handleClose"
        />
        <Button
          v-if="pathOr(false, ['userExecutiveRoleId'], item)"
          variant="primary"
          :text="$lang.submit"
          class="mobile-width-percent-100 tablet-width-percent-100"
          contentClass="justify-content-center"
          :loading="loading"
          @click="handleSubmit"
        />
      </template>
    </LeftSidebar>
  </div>
</template>

<script>
import inputMixin from "@/mixin/inputMixin.vue";
import LeftSidebar from "@/components/re-design/sidebar/LeftSidebar.vue";
import { EnumDropdown, Input, Button } from "@/components/re-design/forms";
import { required } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { generateError, renderEumOptions, toastAlert } from "@/shared/utils";
import { setConclusionFinalScore } from "@/modules/kanoon/services";

export default {
  mixins: [inputMixin],
  components: { LeftSidebar, EnumDropdown, Input, Button },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: null,
    },
  },
  validations() {
    return {
      form: {
        overall: {},
        strengthAndDevelopment: {},
        finalScore: { required },
      },
    };
  },
  data() {
    return {
      form: {
        finalScore: null,
        overall: null,
        strengthAndDevelopment: null,
      },
      loading: false,
    };
  },
  computed: {
    title() {
      const competencyName = pathOr("", ["name"], this.item);
      return `${this.$lang.conclusionScore} ${competencyName}`;
    },
    finalScoreOptions() {
      // regenerate final score options
      const options = renderEumOptions("competency_score", true);
      return options.map((option) => {
        if (option.id === 0) {
          option.caption = option.caption.replace("0", "w");
        }
        return option;
      });
    },
  },
  watch: {
    item: {
      immediate: true,
      handler(data) {
        if (data) {
          this.form.overall = data.overall;
          this.form.strengthAndDevelopment = data.strengthAndDevelopment;
          // select final score
          const { score } = data;
          this.form.finalScore = this.finalScoreOptions.find(
            (option) => option.id === score
          );
        }
      },
    },
  },
  methods: {
    pathOr,
    handleClose() {
      this.$emit("handleClose");
    },
    handleReload() {
      this.$emit("handleReload");
    },
    getFinalScoreOptions(options) {
      // regenerate final score options
      this.finalScoreOptions = options.map((option) => {
        if (option.id === 0) {
          option.caption = option.caption.replace("0", "w");
        }
        return option;
      });
    },
    async handleSubmit() {
      if (this.$v.$anyError || this.loading) return;

      try {
        this.loading = true;
        const {
          centerExecuteId,
          candidateId,
          overviewId,
          centerExecuteCaseId,
        } = this.item;
        const { overall, strengthAndDevelopment } = this.form;
        const finalScore = pathOr(0, ["finalScore", "id"], this.form);
        const response = await setConclusionFinalScore({
          centerExecuteId,
          candidateId,
          overviewId,
          overall,
          strengthAndDevelopment,
          finalScore,
          centerExecuteCaseId,
        });
        const { message } = response;
        toastAlert(message);
        this.handleClose();
        this.handleReload();
      } catch (error) {
        generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
